import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { TFAMethod } from '../../interfaces/tfa-method';
import * as TfaMethodActions from './tfa-methods.actions';

export const tfaMethodsFeatureKey = 'tfaMethods';

export interface State extends EntityState<TFAMethod> {
  loading: boolean;
  error: unknown;
}

export const adapter: EntityAdapter<TFAMethod> = createEntityAdapter<TFAMethod>();

export const initialState: State = adapter.getInitialState({
  loading: false,
  error: null,
});

export const tfaMethodsReducer = createReducer(
  initialState,
  on(TfaMethodActions.loadTFAMethods, (state) => ({ ...state, loading: true })),
  on(TfaMethodActions.loadTFAMethodsSuccess, (state, action) =>
    adapter.upsertMany(action.tfaMethods, { ...state, loading: false })
  ),
  on(TfaMethodActions.loadTFAMethodsFailure, (state, action) => ({ ...state, error: action.error, loading: false })),
  on(TfaMethodActions.clearTFAMethods, (state) => adapter.removeAll(state))
);

export const selectTfaMethodState = createFeatureSelector<State>(tfaMethodsFeatureKey);

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors(selectTfaMethodState);

export const selectTfaMethodsAll = selectAll;
export const selectTfaMethodsTotal = selectTotal;
export const selectTfaMethodsEntities = selectEntities;
export const selectTfaMethodsIds = selectIds;

export const selectTfaMethodsLoading = createSelector(selectTfaMethodState, (state) => state.loading);
